import Api from "./base/api-base";

export default class BudgetExcelApi {
  download (id) {
    return Api.get({
      endpoint: Api.endpoint.budget_excel_download,
      id: id
    });
  }
}